import { FamilyIcon } from "@/shared/icons";
import { SoundButton } from "@/shared/ui";
import PlayerMenuCharacterDataCard from "@/domains/playerMenu/components/character/data/PlayerMenuCharacterDataCard";
import PlayerMenuCharacterFadeBox from "@/domains/playerMenu/components/character/data/PlayerMenuCharacterFadeBox";

export default function PlayerMenuCharacterFamilyCardContainer() {
  return (
    <PlayerMenuCharacterDataCard>
      <div className="flex flex-col w-full h-full">
        <div className="flex flex-col items-center">
          <div className="w-full relative flex items-center gap-3.5 overflow-clip">
            <PlayerMenuCharacterFadeBox icon={FamilyIcon} />
            <div>
              <div className="text-13 font-bold uppercase">НЕТ СЕМЬИ</div>
              <div className="text-10 font-bold text-white/50 uppercase mt-1">
                ВЫ НЕ СОСТОИТЕ В СЕМЬЕ
              </div>
            </div>
          </div>
        </div>
        <SoundButton className="w-fit h-[2.625rem] gap-2.5 mt-2.5" variant="soft" color="gray">
          <FamilyIcon size={16} />
          НАЙТИ СЕМЬЮ
        </SoundButton>
        <div className="mt-auto text-18 font-bold">Семья</div>
      </div>
    </PlayerMenuCharacterDataCard>
  );
}
